module.exports = __webpack_public_path__ + "img/ma.bee9c054.svg";